"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.BoundingBoxStyled = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var BoundingBoxStyled = _styledComponents.default.div.withConfig({
  displayName: "BoundingBoxstyles__BoundingBoxStyled",
  componentId: "sc-1tp031u-0"
})(["background:", ";border:", ";border-radius:", ";height:100%;opacity:", ";width:100%;"], function (_ref) {
  var config = _ref.config;
  return config.backgroundColor;
}, function (_ref2) {
  var config = _ref2.config;
  return "".concat(parseInt(config.borderWidth, 10), "px ").concat(config.borderStyle, " ").concat(config.borderColor);
}, function (_ref3) {
  var config = _ref3.config;
  return config.borderRadius;
}, function (_ref4) {
  var config = _ref4.config;
  return config.opacity;
});

exports.BoundingBoxStyled = BoundingBoxStyled;

var hoverState = function hoverState(hoverStyle) {
  return "\n  ".concat(BoundingBoxStyled, " {\n    background: ").concat(hoverStyle.backgroundColor, ";\n    border: ").concat(parseInt(hoverStyle.borderWidth, 10), "px ").concat(hoverStyle.borderStyle, " ").concat(hoverStyle.borderColor, ";\n    border-radius: ").concat(hoverStyle.borderRadius, ";\n  }\n");
};

var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "BoundingBoxstyles__ClickableAreaStyled",
  componentId: "sc-1tp031u-1"
})(["", ""], function (_ref5) {
  var disableHover = _ref5.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", ";}", ""], _hotspot.focusVisible, function (_ref6) {
    var hoverStyle = _ref6.hoverStyle;
    return hoverState(hoverStyle);
  }, function (_ref7) {
    var hoverStyle = _ref7.hoverStyle,
        previewHoverState = _ref7.previewHoverState;
    return previewHoverState && hoverState(hoverStyle);
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;